import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import {
  type APIResponse,
  type DefaultMatterFileRepositoryStructure,
} from "@/lib/types";

export const createDefaultMatterFileRepositoryStructureV1 = (
  data: Pick<
    DefaultMatterFileRepositoryStructure,
    "label" | "incidentTypeIds"
  > &
    Partial<DefaultMatterFileRepositoryStructure>,
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<DefaultMatterFileRepositoryStructure>
    >(`${baseFastApiMatterRoute}/default-matter-file-repository-structures`, data)
    .then((res) => res.data);
};

export const updateDefaultMatterFileRepositoryStructureV1 = (
  data: Pick<DefaultMatterFileRepositoryStructure, "id" | "dateModified"> &
    Partial<DefaultMatterFileRepositoryStructure>,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<DefaultMatterFileRepositoryStructure>
    >(`${baseFastApiMatterRoute}/default-matter-file-repository-structures`, data)
    .then((res) => res.data);
};

export const deleteDefaultMatterFileRepositoryStructureV1 = (data: {
  id: string;
}) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<DefaultMatterFileRepositoryStructure>
    >(`${baseFastApiMatterRoute}/default-matter-file-repository-structures/${id}`)
    .then((res) => res.data);
};
